import React from "react";
import Button from "components/CustomButtons/Button.js";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import { makeStyles } from "@mui/styles";
import DeleteIcon from "@mui/icons-material/Delete";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function CustomDeleteButton(props) {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const classes = useStyles();

  return (
    <>
      <Button
        style={
          {
          height: props.size? props.size : "32px",
          width: props.size? props.size : "32px",
          padding: "0px",
          margin: "0px",
          marginLeft: "5px",
          // backgroundColor: "#F44336",
          }
      }
        color={"danger"}
        className={classes.actionButton}
        onClick={handleClickOpen}
        disabled={props.disabled}
      >
        <DeleteIcon/>
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {props.deleteTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText style={{ color: "black" }}>
            {props.deleteSubTitle}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Annuler
          </Button>
          <Button
            onClick={() => {
              props.handleSupprimer();
              handleClose();
            }}
            color="danger"
          >
            {" "}
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
